export var instructionsPlaceholder = 'E.g. Dial 555 for gate, park in back';
export var EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE;
(function (EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE) {
    EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE["DEFAULT"] = "We will do our best to follow your delivery guidance, but we cannot guarantee that all deliveries can accommodate your request.";
    EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE["SUCCESS"] = "Your delivery instructions have been updated.";
})(EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE || (EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE = {}));
export var MAX_FORM_FIELDS_LENGTHS = {
    securityCode: 8,
    lockboxLocation: 25,
    lockboxCode: 8,
    siteConditions: 45,
    additionalInstructions: 200,
    otherPropertyType: 21,
};
